const loginWithUserIdandPasswordForm = {
  loginWithNameAndMobileForm: {
    width: "100%",
    display: "grid",
    gap: "20px",
  },
};

export default loginWithUserIdandPasswordForm;
